export class IuguCard {
	id: string;
	description: string;
	data: IuguData; // vem do serviço ou extra_info pelo IuguJS

	constructor(obj: any = { }) {
		Object.assign(this, obj);

		if (obj.extra_info) {
			this.data = obj.extra_info;
		}
	}
}

export interface IuguData {
	bin: string;
	brand: string;
	display_number: string;
	holder_name: string;
	month: string;
	year: string;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/card/iugu-card.model.ts